<template>
    <div id="insights" ref="insights" class="container-fluid">
        <div class="row">
            <div class="col">
                <div class="card card-body mb-4" id="loadedInsight">
                    <vue-markdown :source="insights" />
                </div>
            </div>
        </div>
    </div>    
</template>
<!-- style>
#loadedInsight p {
  margin-bottom: 0;
}
li p {
  float: left;
  margin-top: -25px;
}
</style -->
<script>
import axios from "axios";
import VueMarkdown from 'vue-markdown-render';
export default {
  name: "Report Insights",
  components: {
    VueMarkdown
  },
  props: {
    passedData: {
      type: String,
      default() {
        return "Dataset";
      },
    },
  },
  data() {
    return {
      testDataElem: null,
      insights: []
    };
  },
  methods: {
    
  },
  mounted() {
    const reportName = this.passedData;
    axios
      .get("/get_insights", {
        params: { report: reportName },
      })
      .then((response) => {
        this.insights = response.data;
        console.log('cur '+JSON.stringify(this.insights))
      });
  }
};
</script>